<template>
  <div>
    <Breadtabsheader/>
    <div class="h-piece w-piece">
      <div class="h-pieceTitle2">
        <h1>返利测算</h1>
      </div>
      <div class="h-pieceCon2">
        <div class="h-formLine message">
          <el-form :model="fl" label-position="right" ref="formLabelAlign" :inline="true" class="demo-ruleForm h-formbLine">
            <el-form-item prop="areaCode" label="区域" class="h-elformWrap-2">
              <brselect category="YLRegion" :v="fl.areaCode" v-model="fl.areaCode"/>
            </el-form-item>
            <el-form-item label="客户" class="h-elformWrap-2" prop="customerName">
              <el-select
                  v-model="fl.customerName"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入经销商名称"
                  :remote-method="getCustomerPage"
                  :loading="loading"
                  @change="selectResult">
                <el-option
                    v-for="item in agentList"
                    :key="item.agentCode"
                    :label="item.agentName"
                    :value="item.agentName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="field" label="领域" class="h-elformWrap-2">
              <el-select v-model="fl.field" style="width: 100%">
                <el-option v-for="item in fieldOptions" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="测算周期" prop="radio" style="width: 50%;" class="h-elformWrap-2">
              <el-radio-group v-model="radio">
                <el-radio :label="1">月度返利</el-radio>
                <el-radio :label="2">季度返利</el-radio>
              </el-radio-group>
            </el-form-item>
            <br>
          </el-form>
          <div style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 0.2rem;">
            <div style="padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #2686e7;color: #fff;font-size: 0.16rem;text-align: center;cursor: pointer;"
                 @click="shengcheng">测算
            </div>
          </div>
          <br>
        </div>
        <div v-if="noTarget"><span style="color: red;font-size: 13px">未查询到目标数据，请检查区域、经销商名称、领域是否正确</span></div>
        <div class="h-table h-mrt30 " style="margin: 5px 0 0 5px;">
            <div v-if="cs_yue">
              <table style ="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;" cellspacing =0 border="1">
              <tr style="background-color: White; text-align: center; color:black;">
                <td style="width: 80px" class="h-head">周期</td>
                <td style="width: 150px" class="h-head">条件</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">完成率</td>
                <td style="width: 200px" class="h-head" v-if="cs_yue_fl">返利预测金额（含税）</td>
                <td style="width: 450px;" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" rowspan = "3" class="h-head">{{month.month1}}</td>
                <td style="width: 100px" class="h-text">目标≥15万</td>
                <td style="width: 80px" class="h-text">3%</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month1Goal" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month1Sales" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month1Base" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">{{month1Lvyue}}</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month1Rebate}}</td>
                <td style="width: 100px" rowspan = "9" class="remark">
                  1.该返利测算规则只适用于签约协议为一级经销商的客户，其他类型不适用。<br/>
                  2.填写正确的公司名称并选择领域后，自带出目标、销额，目标不可更改，销额、基数可进行调整，点击测算按钮进行测算。<br/>
                  3.该返利测算金额仅为预测金额，最终实际返利金额以财务测算为准。<br/>
                  4.仅供测算参考，最终解释权归青岛海尔生物医疗设备有限公司。<br/>
                  5、目标、实际、返利基数均为含税金额<br/>(单位：万元)<br/>
                  6、实际金额为OMS系统中销售样表<br/>【是否计入销额】字段“是”<br/>
                  7、返利基数为OMS系统中销售样表<br/>【是否计入基数】字段“是”<br/>
                  8、分销商运营费为签约三方协议的客户<br/>在OMS系统下单金额*5%
                </td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">分销商运营费</td>
                <td style="width: 80px" class="h-text">5%</td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month1BaseFx" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month1RebateFx}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" colspan = "2" class="h-head">月度合计</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month1Goal" readonly/>
                </td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month1Sales" readonly/>
                </td>
                <td style="width: 100px" class="h-text">{{month1BaseHj}}</td>
                <td style="width: 100px" class="h-text">{{month1LvyueHj}}</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month1RebateHj}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" rowspan = "3" class="h-head">{{month.month2}}</td>
                <td style="width: 100px" class="h-text">目标≥15万</td>
                <td style="width: 80px" class="h-text">3%</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month2Goal" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month2Sales" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month2Base" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">{{month2Lvyue}}</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month2Rebate}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">分销商运营费</td>
                <td style="width: 80px" class="h-text">5%</td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month2BaseFx" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month2RebateFx}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" colspan = "2" class="h-head">月度合计</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month2Goal" readonly/>
                </td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month2Sales" readonly/>
                </td>
                <td style="width: 100px" class="h-text">{{month2BaseHj}}</td>
                <td style="width: 100px" class="h-text">{{month2LvyueHj}}</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month2RebateHj}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" rowspan = "3" class="h-head">{{month.month3}}</td>
                <td style="width: 100px" class="h-text">目标≥15万</td>
                <td style="width: 80px" class="h-text">3%</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month3Goal" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');" :readonly="isReadOnly"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month3Sales" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month3Base" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">{{month3Lvyue}}</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month3Rebate}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">分销商运营费</td>
                <td style="width: 80px" class="h-text">5%</td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-edit">
                  <el-input v-model="month.month3BaseFx" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" class="h-text">/</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month3RebateFx}}</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" colspan = "2" class="h-head">月度合计</td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month3Goal" readonly/>
                </td>
                <td style="width: 100px" class="h-count">
                  <el-input v-model="month.month3Sales" readonly/>
                </td>
                <td style="width: 100px" class="h-text">{{month3BaseHj}}</td>
                <td style="width: 100px" class="h-text">{{month3LvyueHj}}</td>
                <td style="width: 100px" class="h-result"  v-if="cs_yue_fl">{{month.month3RebateHj}}</td>
              </tr>
              </table>
            </div>
            <div v-if="cs_jidu">
              <table style ="border-collapse: collapse;width:98%; margin-bottom: 20px ;margin-top: 20px;border:none;height:25px;" cellspacing =0 border="1">
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 80px" rowspan = "25" class="h-head">季度</td>
                <td style="width: 100px" class="h-head">返利归属<br/>产业</td>
                <td style="width: 200px" colspan = "2" class="h-head">台阶（目标）与<br/>奖励系数对照</td>
                <td style="width: 80px" class="h-head">奖励系数</td>
                <td style="width: 100px" class="h-head">季度目标</td>
                <td style="width: 100px" class="h-head">实际</td>
                <td style="width: 100px" class="h-head">返利基数</td>
                <td style="width: 100px" class="h-head">季度完成率</td>
                <td style="width: 150px" class="h-head">返利预测金额<br/>（含税）</td>
                <td style="width: 400px" class="h-head">备注说明</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan = "5" class="h-text">数智样本</td>
                <td style="width: 100px" class="h-text">X<20</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ybw" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.goal_ybw" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.sales_ybw" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.base_ybw" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-text">{{jiduLvyue_ybw}}</td>
                <td style="width: 150px" rowspan = "5" class="h-result">{{jidu.rebate_ybw}}</td>
                <td style="width: 400px" rowspan = "5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属数智样本产业的销售额完成率≥100%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">20≤X<100</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">100≤X<180</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">180≤X<300</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">300≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan = "5" class="h-text">智慧医疗</td>
                <td style="width: 100px" class="h-text">X<20</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ypw" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.goal_ypw" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.sales_ypw" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.base_ypw" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-text">{{jiduLvyue_ypw}}</td>
                <td style="width: 150px" rowspan = "5" class="h-result">{{jidu.rebate_ypw}}</td>
                <td style="width: 400px" rowspan = "5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属智慧医疗产业的销售额完成率≥100%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">20≤X<60</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">60≤X<120</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X<180</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">180≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan = "5" class="h-text">智慧血液</td>
                <td style="width: 100px" class="h-text">X<6</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_ND5" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.goal_ND5" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.sales_ND5" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.base_ND5" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-text">{{jiduLvyue_ND5}}</td>
                <td style="width: 150px" rowspan = "5" class="h-result">{{jidu.rebate_ND5}}</td>
                <td style="width: 400px" rowspan = "5" class="remark">①每季度签约销售额符合各产业季度奖励台阶<br/>②整体完成率100%及以上<br/>③归属智慧血液产业的销售额完成率≥100%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">6≤X<30</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">30≤X<90</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">90≤X<120</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">120≤X</td>
                <td style="width: 100px" class="h-text">4%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan = "5" class="h-text">实验室设备</td>
                <td style="width: 100px" class="h-text">X<15</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv_swaq" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.goal_swaq" readonly/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.sales_swaq" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.base_swaq" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-text">{{jiduLvyue_swaq}}</td>
                <td style="width: 150px" rowspan = "5" class="h-result">{{jidu.rebate_swaq}}</td>
                <td style="width: 400px" rowspan = "5" class="remark">①每季度签约销售额符合实验室设备产业的奖励台阶<br/>②归属实验室设备产业的销售额完成率≥100%</td>
              </tr>
                <tr style="background-color: White; text-align: center; color:black;height:30px;">
                  <td style="width: 100px" class="h-text">15≤X<50</td>
                  <td style="width: 100px" class="h-text">2%</td>
                </tr>
                <tr style="background-color: White; text-align: center; color:black;height:30px;">
                  <td style="width: 100px" class="h-text">50≤X<90</td>
                  <td style="width: 100px" class="h-text">3%</td>
                </tr>
                <tr style="background-color: White; text-align: center; color:black;height:30px;">
                  <td style="width: 100px" class="h-text">90≤X<120</td>
                  <td style="width: 100px" class="h-text">4%</td>
                </tr>
                <tr style="background-color: White; text-align: center; color:black;height:30px;">
                  <td style="width: 100px" class="h-text">120≤X</td>
                  <td style="width: 100px" class="h-text">5%</td>
                </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" rowspan = "4" class="h-text">传统整体</td>
                <td style="width: 100px" class="h-text">X<35</td>
                <td style="width: 100px" class="h-text">0%</td>
                <td style="width: 100px" rowspan = "5" class="h-count">
                  <el-input v-model="jidu.jichuXishuLv" readonly/>
                </td>
                <td style="width: 100px" rowspan = "4" class="h-count">
                  <el-input v-model="jidu.goal" readonly/>
                </td>
                <td style="width: 100px" rowspan = "4" class="h-edit">
                  <el-input v-model="jidu.sales" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "5" class="h-edit">
                  <el-input v-model="jidu.base" maxlength="7" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');"/>
                </td>
                <td style="width: 100px" rowspan = "4" class="h-text">{{jiduLvyue_ct}}</td>
                <td style="width: 150px" rowspan = "4" class="h-result">{{jidu.rebate}}</td>
                <td style="width: 400px" rowspan = "4" class="remark">①季度整体目标完成率100%及以上<br/>②季度内每月完成率均不低于70%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">35≤X<210</td>
                <td style="width: 100px" class="h-text">1%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">210≤X<410</td>
                <td style="width: 100px" class="h-text">2%</td>
              </tr>
              <tr style="background-color: White; text-align: center; color:black;height:30px;">
                <td style="width: 100px" class="h-text">410≤X</td>
                <td style="width: 100px" class="h-text">3%</td>
              </tr>
              </table>
            </div>
        </div>
        <div style="text-align: center" v-if="fl_cesuan">
          <br/>
          <el-button class="h-btn h-bBtn h-bggreen" @click="flRebateCalculate()">返利测算</el-button>
          <br/>
          <br/>
          <br/>
        </div>
        <div class="yx_progressBar" v-if="result_jidu || result_month">
          <div class="yx_topTip">
            <div class="leftdes" v-if="result_month">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>月度返利：</span>
                </el-col>
                <el-col :span="4">
                  <span>{{month.month1}}：{{month.month1RebateHj}}</span>
                </el-col>
                <el-col :span="4">
                  <span>{{month.month2}}：{{month.month2RebateHj}}</span>
                </el-col>
                <el-col :span="4">
                  <span>{{month.month3}}：{{month.month3RebateHj}}</span>
                </el-col>
                <el-col :span="9"></el-col>
              </el-row>
            </div>
            <br/>
            <div class="leftdes" v-if="result_jidu">
              <el-row type="flex" style="flex-wrap: wrap;width:100%">
                <el-col :span="3">
                  <span>季度返利：</span>
                </el-col>
                <el-col :span="2">
                  {{jidu.jiduRebate}}
                </el-col>
                <el-col :span="19"></el-col>
              </el-row>
            </div>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import nc from '../../../utils/numberCalc';
import ss from '../../../api/SystemService';
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      cs_yue:false,
      cs_jidu:false,
      cs_yue_fl:false,
      fl_cesuan:false,
      result_month:false,
      result_jidu:false,
      result_all:false,
      radio:1,
      chooseRadio:1,
      isReadOnly: false,
      noTarget:false,
      fieldOptions: [ // 下拉菜单的选项
        { value: 1, label: '生命科学' },
        { value: 2, label: '医疗创新' }
      ],
      agentList:[],
      state:false,
      fl:{
        customerName:null,
        field:null,
        areaCode:null,
      },
      month:{
        month1:null,
        month2:null,
        month3:null,
        monthXishu:0.03,
        monthXishuFx:0.05,
        month1Goal:0,
        month2Goal:0,
        month3Goal:0,
        month1Sales:null,
        month2Sales:null,
        month3Sales:null,
        month1Base:null,
        month2Base:null,
        month3Base:null,
        month1Lvyue:0.00,
        month2Lvyue:0.00,
        month3Lvyue:0.00,
        month1Rebate:0.00,
        month2Rebate:0.00,
        month3Rebate:0.00,
        month1BaseFx:0.00,
        month2BaseFx:0.00,
        month3BaseFx:0.00,
        month1RebateFx:0.00,
        month2RebateFx:0.00,
        month3RebateFx:0.00,
        month1BaseHj:0,
        month2BaseHj:0,
        month3BaseHj:0,
        month1LvyueHj:0.00,
        month2LvyueHj:0.00,
        month3LvyueHj:0.00,
        month1RebateHj:0.00,
        month2RebateHj:0.00,
        month3RebateHj:0.00,
      },
      jidu:{
        jichuXishu:0,
        jichuXishu_ybw:0,
        jichuXishu_ypw:0,
        jichuXishu_swaq:0,
        jichuXishu_ND5:0,
        jichuXishuLv:'0%',
        jichuXishuLv_ybw:'0%',
        jichuXishuLv_ypw:'0%',
        jichuXishuLv_swaq:'0%',
        jichuXishuLv_ND5:'0%',
        sales_ybw:null,
        base_ybw:null,
        sales_ypw:null,
        base_ypw:null,
        sales_swaq:null,
        base_swaq:null,
        sales_ND5:null,
        base_ND5:null,
        sales:0,
        base:0,
        goal:0,
        goal_ybw:0,
        goal_ypw:0,
        goal_swaq:0,
        goal_ND5:0,
        lvyue_ybw:0,
        lvyue_ypw:0,
        lvyue_swaq:0,
        lvyue_ND5:0,
        lvyue:0,
        lvyueLv_ybw:null,
        lvyueLv_ypw:null,
        lvyueLv_swaq:null,
        lvyueLv_ND5:null,
        rebate:0,
        rebate_ybw:0,
        rebate_ypw:0,
        rebate_swaq:0,
        rebate_ND5:0,
        jiduRebate:0,
      },
      areaName: sessionStorage.getItem("areaName") || ''
    }
  },
  created() {
    this.setMonthTitle();
    this.localAgent();
  },
  computed:{
    /*月度返利计算*/
    //履约率 = 销额/目标
    month1Lvyue: function () {
      if(this.month.month1Goal && this.month.month1Sales){
        if(this.month.month1Goal > 0 && this.month.month1Sales > 0){
          this.month.month1Lvyue = nc.div(this.month.month1Sales,this.month.month1Goal).toFixed(4);
          return this.getLvyueLv(this.month.month1Lvyue);
        }else{
          return '0.00%';
        }
      }else{
        return null;
      };
    },
    month2Lvyue: function () {
      if(this.month.month2Goal && this.month.month2Sales){
        if(this.month.month2Goal > 0 && this.month.month2Sales > 0){
          this.month.month2Lvyue = nc.div(this.month.month2Sales,this.month.month2Goal).toFixed(4);
          return this.getLvyueLv(this.month.month2Lvyue);
        }else{
          return '0.00%';
        }
      }else{
        return null;
      };
    },
    month3Lvyue: function () {
      if(this.month.month3Goal && this.month.month3Sales){
        if(this.month.month3Goal > 0 && this.month.month3Sales > 0){
          this.month.month3Lvyue = nc.div(this.month.month3Sales,this.month.month3Goal).toFixed(4);
          return this.getLvyueLv(this.month.month3Lvyue);
        }else{
          return '0.00%';
        }
      }else{
        return null;
      };
    },
    //基数合计
    month1BaseHj: function (){
      if(this.month.month1Base){
        this.month.month1BaseHj = nc.add(this.month.month1Base,this.month.month1BaseFx);
        return this.month.month1BaseHj;
      }else{
        return null;
      }
    },
    month2BaseHj: function (){
      if(this.month.month2Base){
        this.month.month2BaseHj = nc.add(this.month.month2Base,this.month.month2BaseFx);
        return this.month.month2BaseHj;
      }else{
        return null;
      }
    },
    month3BaseHj: function (){
      if(this.month.month3Base){
        this.month.month3BaseHj = nc.add(this.month.month3Base,this.month.month3BaseFx);
        return this.month.month3BaseHj;
      }else{
        return null;
      }
    },
    //合计履约率
    month1LvyueHj: function (){
      if(this.month.month1Goal && this.month.month1Sales){
        if(this.month.month1Goal > 0 && this.month.month1Sales > 0){
          this.month.month1LvyueHj = nc.div(this.month.month1Sales,this.month.month1Goal).toFixed(4);
          return this.getLvyueLv(this.month.month1LvyueHj);
        }else{
          return '0.00%';
        }
      }else{
        return null;
      };
    },
    month2LvyueHj: function (){
      if(this.month.month2Goal && this.month.month2Sales){
        if(this.month.month2Goal > 0 && this.month.month2Sales > 0){
          this.month.month2LvyueHj = nc.div(this.month.month2Sales,this.month.month2Goal).toFixed(4);
          return this.getLvyueLv(this.month.month2LvyueHj);
        }else{
          return '0.00%';
        }
      }else{
        return null;
      };
    },
    month3LvyueHj: function (){
      if(this.month.month3Goal && this.month.month3Sales){
        if(this.month.month3Goal > 0 && this.month.month3Sales > 0){
          this.month.month3LvyueHj = nc.div(this.month.month3Sales,this.month.month3Goal).toFixed(4);
          return this.getLvyueLv(this.month.month3LvyueHj);
        }else{
          return '0.00%';
        }
      }else{
        return null;
      };
    },
    /*季度返利计算*/
    //季度基数
    jiduBase:function (){
      this.jidu.base = nc.add(this.jidu.base_ybw,this.jidu.base_ypw,this.jidu.base_swaq,this.jidu.base_ND5);
      return this.jidu.base;
    },
    //季度履约率
    jiduLvyue_ybw:function (){
      this.jidu.lvyue_ybw = this.jidu.goal_ybw>0?nc.div(this.jidu.sales_ybw,this.jidu.goal_ybw).toFixed(4):0;
      return this.getLvyueLv(this.jidu.lvyue_ybw);
    },
    jiduLvyue_ypw:function (){
      this.jidu.lvyue_ypw = this.jidu.goal_ypw>0?nc.div(this.jidu.sales_ypw,this.jidu.goal_ypw).toFixed(4):0;
      return this.getLvyueLv(this.jidu.lvyue_ypw);
    },
    jiduLvyue_swaq:function (){
      this.jidu.lvyue_swaq = this.jidu.goal_swaq>0?nc.div(this.jidu.sales_swaq,this.jidu.goal_swaq).toFixed(4):0;
      return this.getLvyueLv(this.jidu.lvyue_swaq);
    },
    jiduLvyue_ND5:function (){
      this.jidu.lvyue_ND5 = this.jidu.goal_ND5>0?nc.div(this.jidu.sales_ND5,this.jidu.goal_ND5).toFixed(4):0;
      return this.getLvyueLv(this.jidu.lvyue_ND5);
    },
    jiduLvyue_ct:function (){
      this.jidu.lvyue = this.jidu.goal>0?nc.div(this.jidu.sales,this.jidu.goal).toFixed(4):0;
      return this.getLvyueLv(this.jidu.lvyue);
    },
  },
  methods:{
    // changeArea(obj){
    //   if(obj){
    //     sessionStorage.removeItem('areaName')
    //   }
    // },
    setResultFalse(){
      this.result_month = false;
      this.result_jidu = false;
    },
    //季度基础系数
    getJiduJichuXishu(goal,cy){
      if('ct' == cy){
        if(goal >= 410 ){
          return 0.03;
        }else if(goal >= 210 ){
          return 0.02;
        }else if(goal >= 35 ){
          return 0.01;
        }else{
          return 0;
        }
      }else if('szyb' == cy){
        if(goal >= 300 ){
          return 0.04;
        }else if(goal >= 180 ){
          return 0.03;
        }else if(goal >= 100 ){
          return 0.02;
        }else if(goal >= 20 ){
          return 0.01;
        }else{
          return 0;
        }
      }else if('zhyl' == cy){
        if(goal >= 180 ){
          return 0.04;
        }else if(goal >= 120 ){
          return 0.03;
        }else if(goal >= 60 ){
          return 0.02;
        }else if(goal >= 20 ){
          return 0.01;
        }else{
          return 0;
        }
      }else if('zhxy' == cy){
        if(goal >= 120 ){
          return 0.04;
        }else if(goal >= 90 ){
          return 0.03;
        }else if(goal >= 30 ){
          return 0.02;
        }else if(goal >= 6 ){
          return 0.01;
        }else{
          return 0;
        }
      }else if('syssb' == cy){
        if(goal >= 120 ){
          return 0.05;
        }else if(goal >= 90 ){
          return 0.04;
        }else if(goal >= 50 ){
          return 0.03;
        }else if(goal >= 15 ){
          return 0.02;
        }else{
          return 0;
        }
      }
    },
    //履约率%
    getLvyueLv(lvyue){
      return nc.mul(lvyue,100).toFixed(2)+'%';
    },
    setMonthTitle(){
      //设置月份
      const date = new Date();
      const currentMonth = date.getMonth() + 1
      if(currentMonth == 1 || currentMonth == 4  || currentMonth == 7 || currentMonth == 10 ){
        this.month.month1 = currentMonth+'月';
        this.month.month2 = (currentMonth+1)+'月';
        this.month.month3 = (currentMonth+2)+'月';
      }else if(currentMonth == 2 || currentMonth == 5  || currentMonth == 8 || currentMonth == 11 ){
        this.month.month2 = currentMonth+'月';
        this.month.month3 = (currentMonth+1)+'月';
        this.month.month1 = (currentMonth-1)+'月';
      }else if(currentMonth == 3 || currentMonth == 6  || currentMonth == 9 || currentMonth == 12 ){
        this.month.month3 = currentMonth+'月';
        this.month.month2 = (currentMonth-1)+'月';
        this.month.month1 = (currentMonth-2)+'月';
      }
    },
    selectFlInfoByAgent(){
      if(this.fl.customerName && this.fl.areaCode && this.fl.field){
        this.setZero();
        this.noTarget = false;
        this.getTargetByCustomer();
        if(!this.noTarget){
          this.getBaseByCustomer();
        }
      }
    },
    //销额基数设置0
    setZero(){
      this.setMonthZero();
      this.setJiduZero();
    },
    setMonthZero(){
      //月度
      this.month.month1Goal = 0;
      this.month.month2Goal = 0;
      this.month.month3Goal = 0;
      this.month.month1Sales = 0;
      this.month.month2Sales = 0;
      this.month.month3Sales = 0;
      this.month.month1Base = 0;
      this.month.month2Base = 0;
      this.month.month3Base = 0;
      this.month.month1BaseFx = 0;
      this.month.month2BaseFx = 0;
      this.month.month3BaseFx = 0;
      this.month.month1Rebate = 0;
      this.month.month2Rebate = 0;
      this.month.month3Rebate = 0;
      this.month.month1RebateHj = 0;
      this.month.month2RebateHj = 0;
      this.month.month3RebateHj = 0;
      this.month.month1RebateFx = 0;
      this.month.month2RebateFx = 0;
      this.month.month3RebateFx = 0;
    },
    setJiduZero(){
      //季度
      this.jidu.goal_ybw = 0;
      this.jidu.goal_ypw = 0;
      this.jidu.goal_swaq = 0;
      this.jidu.goal_ND5 = 0;
      this.jidu.goal = 0;
      this.jidu.sales_ybw = 0;
      this.jidu.sales_ypw = 0;
      this.jidu.sales_swaq = 0;
      this.jidu.sales_ND5 = 0;
      this.jidu.sales = 0;
      this.jidu.base_ybw = 0;
      this.jidu.base_ypw = 0;
      this.jidu.base_swaq = 0;
      this.jidu.base_ND5 = 0;
      this.jidu.base = 0;
      this.jidu.rebate_ybw = 0;
      this.jidu.rebate_ypw = 0;
      this.jidu.rebate_swaq = 0;
      this.jidu.rebate_ND5 = 0;
      this.jidu.rebate = 0;
      this.jidu.jiduRebate = 0;
    },
    //查询目标、销额
    getTargetByCustomer(){
      ss.fanli.getTargetByCustomer(this.fl.customerName,this.fl.areaCode,this.fl.field).then(rd => {
        if(rd.obj && rd.obj.length>0){
          console.log("查询目标：",rd.obj)
          this.isReadOnly = true;
          //初始化目标销额为0
          for(const element of rd.obj) {
            var goal = element;
            if(goal.type == '1'){
              this.month.month1Goal = goal.goal1;
              this.month.month2Goal = goal.goal2;
              this.month.month3Goal = goal.goal3;
              this.month.month1Sales = goal.sales1;
              this.month.month2Sales = goal.sales2;
              this.month.month3Sales = goal.sales3;
            }else if(goal.type == '2'){
              if(goal.lianqun == 'szyb'){
                this.jidu.goal_ybw = goal.goal4;
                this.jidu.sales_ybw = goal.sales4;
                this.jidu.jichuXishu_ybw = this.getJiduJichuXishu(this.jidu.goal_ybw,goal.lianqun);
                this.jidu.jichuXishuLv_ybw = nc.mul(this.jidu.jichuXishu_ybw,100)+'%';
              }else if(goal.lianqun == 'zhyl'){
                this.jidu.goal_ypw = goal.goal4;
                this.jidu.sales_ypw = goal.sales4;
                this.jidu.jichuXishu_ypw = this.getJiduJichuXishu(this.jidu.goal_ypw,goal.lianqun);
                this.jidu.jichuXishuLv_ypw = nc.mul(this.jidu.jichuXishu_ypw,100)+'%';
              }else if(goal.lianqun == 'syssb'){
                this.jidu.goal_swaq = goal.goal4;
                this.jidu.sales_swaq = goal.sales4;
                this.jidu.jichuXishu_swaq = this.getJiduJichuXishu(this.jidu.goal_swaq,goal.lianqun);
                this.jidu.jichuXishuLv_swaq = nc.mul(this.jidu.jichuXishu_swaq,100)+'%';
              }else if(goal.lianqun == 'zhxy'){
                this.jidu.goal_ND5 = goal.goal4;
                this.jidu.sales_ND5 = goal.sales4;
                this.jidu.jichuXishu_ND5 = this.getJiduJichuXishu(this.jidu.goal_ND5,goal.lianqun);
                this.jidu.jichuXishuLv_ND5 = nc.mul(this.jidu.jichuXishu_ND5,100)+'%';
              }
              //季度目标销额求和
              this.jidu.goal = nc.add(this.jidu.goal_ybw,this.jidu.goal_ypw,this.jidu.goal_swaq,this.jidu.goal_ND5);
              this.jidu.sales = nc.add(this.jidu.sales_ybw,this.jidu.sales_ypw,this.jidu.sales_swaq,this.jidu.sales_ND5);
              this.jidu.jichuXishu = this.getJiduJichuXishu(this.jidu.goal,'ct');
              this.jidu.jichuXishuLv = nc.mul(this.jidu.jichuXishu,100)+'%';
            }
          }
        }else{
          this.noTarget = true;
        }
      })
    },
    //查询基数
    getBaseByCustomer(){
      ss.fanli.getBaseByCustomer(this.fl.customerName,this.fl.areaCode,this.fl.field).then(rd => {
        if(rd.obj){
          for(const element of rd.obj) {
            //月度
            if(element.type == '1'){
              if(element.agentType == 'yjjxs'){
                if(element.month == '1' || element.month == '4' || element.month == '7' || element.month == '10'){
                  this.month.month1Base = element.base;
                }else if(element.month == '2' || element.month == '5' || element.month == '8' || element.month == '11'){
                  this.month.month2Base = element.base;
                }else if(element.month == '3' || element.month == '6' || element.month == '9' || element.month == '1'){
                  this.month.month3Base = element.base;
                }
              }else if(element.agentType == 'fxs'){
                if(element.month == '1' || element.month == '4' || element.month == '7' || element.month == '10'){
                  this.month.month1BaseFx = element.base;
                }else if(element.month == '2' || element.month == '5' || element.month == '8' || element.month == '11'){
                  this.month.month2BaseFx = element.base;
                }else if(element.month == '3' || element.month == '6' || element.month == '9' || element.month == '1'){
                  this.month.month3BaseFx = element.base;
                }
              }
            }else if(element.type == '2'){
              if(element.lianqun == 'szyb'){
                this.jidu.base_ybw = element.base;
              }else if(element.lianqun == 'zhyl'){
                this.jidu.base_ypw = element.base;
              }else if(element.lianqun == 'syssb'){
                this.jidu.base_swaq = element.base;
              }else if(element.lianqun == 'zhxy'){
                this.jidu.base_ND5 = element.base;
              }else if(element.lianqun == 'ct'){
                this.jidu.base = element.base;
              }
            }
          }
        }
      })
    },
    //返利测算
    flRebateCalculate(){
      this.setResultFalse();
      this.setRebateZero();
      //月度返利计算
      if(this.chooseRadio == 1){
        this.monthRebate();
        this.result_month = true;
      }else if(this.chooseRadio == 2){
        this.monthRebate();
        this.result_month = true;
        //季度返利计算
        this.jiduRebate();
        this.result_jidu = true;
      }
      //日志
      this.rebateLog();
    },
    monthRebate(){
      //分销商运营服务费 = 分销商基数 * 0.05
      if(this.month.month1BaseFx){
        this.month.month1RebateFx = nc.mul(this.month.month1BaseFx,this.month.monthXishuFx);
      }
      if(this.month.month2BaseFx){
        this.month.month2RebateFx = nc.mul(this.month.month2BaseFx,this.month.monthXishuFx);
      }
      if(this.month.month3BaseFx){
        this.month.month3RebateFx = nc.mul(this.month.month3BaseFx,this.month.monthXishuFx);
      }
      //月返利
      if(this.month.month1Goal >= 15 && this.month.month1LvyueHj >= 1){
        this.month.month1Rebate =  nc.mul(this.month.month1BaseHj,this.month.monthXishu);
      }else{
        this.month.month1Rebate = 0.00;
      }
      if(this.month.month2Goal >= 15 && this.month.month2LvyueHj >= 1){
        this.month.month2Rebate =  nc.mul(this.month.month2BaseHj,this.month.monthXishu);
      }else{
        this.month.month2Rebate = 0.00;
      }
      if(this.month.month3Goal >= 15 && this.month.month3LvyueHj >= 1){
        this.month.month3Rebate =  nc.mul(this.month.month3BaseHj,this.month.monthXishu);
      }else{
        this.month.month3Rebate = 0.00;
      }
      //返利合
      this.month.month1RebateHj = nc.add(this.month.month1Rebate,this.month.month1RebateFx);
      this.month.month2RebateHj = nc.add(this.month.month2Rebate,this.month.month2RebateFx);
      this.month.month3RebateHj = nc.add(this.month.month3Rebate,this.month.month3RebateFx);
    },
    jiduRebate(){
      //样本、智慧医疗、智慧血液需要整体100%以上，自身也100%以上，可计算返利
      if(this.jidu.lvyue >= 1){
        //数智样本
        if(this.jidu.lvyue_ybw >= 1){
          this.jidu.rebate_ybw = nc.mul(this.jidu.base_ybw,this.jidu.jichuXishu_ybw);
        }
        //智慧医疗
        if(this.jidu.lvyue_ypw >= 1){
          this.jidu.rebate_ypw = nc.mul(this.jidu.base_ypw,this.jidu.jichuXishu_ypw);
        }
        //智慧血液
        if(this.jidu.lvyue_ND5 >= 1){
          this.jidu.rebate_ND5 = nc.mul(this.jidu.base_ND5,this.jidu.jichuXishu_ND5);
        }
        //传统整体
        //判断每月完成率均不低于70%
        if(this.month.month1LvyueHj >= 0.7 && this.month.month2LvyueHj >= 0.7 && this.month.month3LvyueHj >= 0.7){
          this.jidu.rebate = nc.mul(this.jidu.base,this.jidu.jichuXishu);
        }else{
          this.jidu.rebate = 0;
        }
      }else{
        this.jidu.rebate_ybw = 0;
        this.jidu.rebate_ypw = 0;
        this.jidu.rebate_ND5 = 0;
        this.jidu.rebate = 0;
      }
      //实验室设备
      if(this.jidu.lvyue_swaq >= 1){
        this.jidu.rebate_swaq = nc.mul(this.jidu.base_swaq,this.jidu.jichuXishu_swaq);
      }else{
        this.jidu.rebate_swaq = 0;
      }

      this.jidu.jiduRebate = nc.add(this.jidu.rebate_ybw,this.jidu.rebate_ypw,this.jidu.rebate_swaq,this.jidu.rebate_ND5,this.jidu.rebate);
    },
    //测算日志记录
    rebateLog(){
      ss.fanli.rebateLog(this.fl.customerName,this.chooseRadio).then(rd => {
        console.log("返利测算结束")
      });
    },
    //当前登录人
    localAgent(){
      ss.fanli.localAgent().then(rd => {
        if(rd.obj){
          this.fl.customerName = rd.obj;
        }
      });
    },
    getCustomerPage(value){
      if (value !== '') {
        this.agentList = [];
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          ss.fanli.getCustomerPage(value).then(rd=>{
            if(rd.obj){
              this.agentList = rd.obj;
            }else{
              this.agentList = [];
            }
          })
        }, 200);
      } else {
        this.agentList = [];
      }

    },
    //选择经销商
    selectResult(value){
      this.fl.customerName = value;
      this.noTarget = false;
      this.fl_cesuan = false;
      this.cs_yue = false;
      this.cs_jidu = false;
      this.cs_yue_fl = this.cs_yue;
      this.setRebateZero();
    },
    shengcheng(){
      //隐藏最后返利计算结果
      this.setResultFalse();
      this.fl_cesuan = false;
      if(this.fl.customerName && this.fl.areaCode && this.fl.field){
        if(this.radio == 1){
          this.cs_yue = true;
          this.cs_jidu = false;
          this.chooseRadio = 1;
        }else if(this.radio == 2){
          this.cs_yue = true;
          this.cs_jidu = true;
          this.chooseRadio = 2;
        }
        this.cs_yue_fl = true;
        this.fl_cesuan = true;
        this.selectFlInfoByAgent();
      }else{
        this.$msg.msge("请先选择区域、经销商和领域");
        return;
      }
    },
    setRebateZero(){
      this.month.month1Rebate = 0;
      this.month.month1RebateFx = 0;
      this.month.month1RebateHj = 0;
      this.month.month2Rebate = 0;
      this.month.month2RebateFx = 0;
      this.month.month2RebateHj = 0;
      this.month.month3Rebate = 0;
      this.month.month3RebateFx = 0;
      this.month.month3RebateHj = 0;
      this.jidu.rebate_ybw = 0;
      this.jidu.rebate_ypw = 0;
      this.jidu.rebate_swaq = 0;
      this.jidu.rebate_ND5 = 0;
      this.jidu.rebate = 0;
      this.jidu.jiduRebate = 0;
      this.result_month = false;
      this.result_jidu = false;
    },
  },
  mounted() {
    if(sessionStorage.getItem("areaName")){
      let areaName = sessionStorage.getItem("areaName")
      this.fl.areaCode = areaName.slice(0,-1)
      let cityListArr = this.$store.getters.dicts['YLRegion']
      let cityCode = cityListArr.filter((o) => o.name == this.fl.areaCode);
      this.fl.areaCode = cityCode[0].code || ''
    }
  }
}
</script>
<style scoped>
 .title{
  font-size: 24px;
  font-weight:bold;
}
.remark{
  padding-left: 2px;
  font-size: 12px;
  text-align: left;
}
.condition{
  font-size: 13px;
  text-align: center;
}
.h-head{
  font-size: 15px;
  text-align: center;
  font-weight:bold;
}
.h-text{
  font-size: 14px;
  text-align: center;
}
::v-deep .h-edit .el-input .el-input__inner{
  font-size: 13px;
  text-align: center;
  width: 100%;
  color: blue;
}
.h-result{
   font-size: 14px;
   text-align: center;
   color: blue;
 }
 ::v-deep .h-count .el-input .el-input__inner{
  font-size: 14px;
  text-align: center;
}
 /* 去掉Element UI的Input边框 */
 ::v-deep .leftdes .el-input__inner {
   border: none !important; /* 使用 !important 来确保覆盖默认样式 */
   box-shadow: none !important;
 }

 /* 如果你还想要去掉聚焦时的边框 */
 ::v-deep .leftdes.el-input__inner:focus {
   outline: none !important;
 }
</style>
<style scoped lang="scss">

  .message .h-formbLine .h-elformWrap-2 {
    width: 33.3333%;
  }

  .tan .h-formbLine .el-form-item__label {
    width: 47%;
  }

  .tan .h-formbLine .el-form-item__content {
    width: 53%
  }

  .tan .h-formbLine .h-elformWrap-2 {
    width: 50%;
  }
  .tan .h-elformWrap-1 .el-form-item__label {
    width: 20%;
  }

  .tan .h-elformWrap-1 .el-form-item__content {
    width: 80%;
  }


  $ft-colorg: #21d16f; //绿色的字
  $ft-coloro: #e79118; //黄色的字
  $bg-colorg: #f6fffa; //绿色的背景色
  $bg-coloro: #fffbf7; //黄色的背景色
  $bg-colorb: #3b77fc; //蓝色
  $bg-colorgrey: #c3c3c3; //灰色
  .yx_progressBar {
    margin: 0.28rem 0;
    width: 100%;
    border: 1px solid $ft-colorg;
    background-color: $bg-colorg;
    padding: 0.38rem;

    .yx_topTip {

      justify-content: flex-start;
      color: #424441;
      font-size: 0.18rem;

      .leftdes {
        margin-right: 0.75rem;
      }
    }
  }
</style>